var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLinkWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 9,
    height: 9,
    viewBox: "0 0 9 9",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.19994 8.99964H0.599995C0.440866 8.99964 0.288255 8.93642 0.175734 8.8239C0.0632135 8.71138 0 8.55877 0 8.39964V1.7997C0 1.64057 0.0632135 1.48796 0.175734 1.37544C0.288255 1.26292 0.440866 1.19971 0.599995 1.19971H3.59997V1.7997H0.599995V8.39964H7.19994V5.39967H7.79993V8.39964C7.79993 8.55877 7.73672 8.71138 7.6242 8.8239C7.51168 8.93642 7.35906 8.99964 7.19994 8.99964Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.49965 0C4.42009 0 4.34378 0.0316068 4.28752 0.0878672C4.23126 0.144128 4.19966 0.220433 4.19966 0.299997C4.19966 0.379562 4.23126 0.455867 4.28752 0.512127C4.34378 0.568388 4.42009 0.599995 4.49965 0.599995H7.97662L3.82166 4.75496C3.79025 4.78185 3.76475 4.81495 3.74674 4.85217C3.72874 4.88939 3.71862 4.92992 3.71702 4.97124C3.71542 5.01255 3.72239 5.05375 3.73747 5.09225C3.75255 5.13075 3.77543 5.16571 3.80466 5.19495C3.8339 5.22418 3.86886 5.24706 3.90736 5.26214C3.94586 5.27723 3.98706 5.28419 4.02837 5.28259C4.06969 5.281 4.11023 5.27088 4.14745 5.25287C4.18467 5.23486 4.21776 5.20936 4.24466 5.17795L8.39962 1.02299V4.49996C8.39962 4.57952 8.43122 4.65583 8.48748 4.71209C8.54375 4.76835 8.62005 4.79996 8.69962 4.79996C8.77918 4.79996 8.85549 4.76835 8.91175 4.71209C8.96801 4.65583 8.99961 4.57952 8.99961 4.49996V0H4.49965Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkWhite);
export default __webpack_public_path__ + "static/media/linkWhite.57b81a89fef29a4829178cd1126ed3db.svg";
export { ForwardRef as ReactComponent };